export default __webpack_public_path__ + "static/media/rechnung.cc6bdfd0.svg";